module.exports = __webpack_public_path__ + "static/media/new_dir_dark_icn.1d4352aa.png";